import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconContributorStorageLimit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 23,
	viewBox: "0 0 19 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 8V3.33333C1 2.04467 2.08731 1 3.42857 1H15.5714C16.9127 1 18 2.04467 18 3.33333V8M1 8H18M1 8V15M18 8V15M1 15V19.6667C1 20.9554 2.08731 22 3.42857 22H15.5714C16.9127 22 18 20.9554 18 19.6667V15M1 15H18M4.64286 11.5H4.655M4.64286 4.5H4.655M4.64286 18.5H4.655",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconContributorStorageLimit;
